import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../config/config';
import Fetch from "../../../../core/util/core/Fetch";
import { chooseProfileFilter } from "../../../helpers/chooseProfileFilter";

function Form() {

    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const { id } = useParams();
    const profileFilter = chooseProfileFilter();

    const path = '/taxes/';
    const paths = {
        endpointSave: config.endpoints.backend + 'taxes/save',
        endpointGetById: config.endpoints.backend + 'taxes/getById',
        endpointGetAllEntities: config.endpoints.backend + 'entities/getall',
        endpointGetAllTaxTypes: config.endpoints.backend + 'taxtypes/getall',
        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const hiddenValues = {}

    if (profileFilter.pdc_entity_id) {
        hiddenValues.pdc_entity_id = profileFilter.pdc_entity_id
    }

    const labels = {
        labelTitleAdd: "Novo Imposto",
        labelTitleEdit: "Editar Imposto",
        labelTitleView: 'Visualizar Imposto'
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            hiddenValues: {
                ...hiddenValues
            },
            fields: [
                !hiddenValues.pdc_entity_id ? {
                    name: 'pdc_entity_id',
                    type: 'select',
                    label: 'Entidade',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllEntities,
                        label: 'corporate_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                } : {},
                {
                    name: 'description',
                    type: 'text',
                    label: 'Nome',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'tax_regime_code',
                    type: 'text',
                    label: 'Código Regime Tributário',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'taxes',
                    type: 'multiinput',
                    label: 'Impostos',
                    sortBy: 'index',
                    unique: true,
                    form: [
                        {
                            name: 'pdc_tax_type_id',
                            type: 'select',
                            label: 'Tipo',
                            unique: true,
                            options: [],
                            optionsEndpoint: {
                                endpoint: paths.endpointGetAllTaxTypes,
                                label: 'name',
                                value: 'id'
                            },
                            validations: {
                                required: true
                            }
                        },
                        {
                            name: 'aliquot',
                            type: 'decimal',
                            label: '% Aliquota',
                            validations: {
                                required: true
                            },
                            columnSize: 12
                        },
                        {
                            name: 'base',
                            type: 'decimal',
                            label: '% Base',
                            validations: {
                                required: true
                            },
                            columnSize: 12
                        },
                    ],
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                },                
                {
                    name: 'status',
                    type: 'select',
                    options: [
                        { label: 'Ativo', value: '1' },
                        { label: 'Inativo', value: '0' }
                    ],
                    label: 'Status',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                }
            ],
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};

            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }
            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
